export default {
  title: 'Confirm order',
  buttons: {
    view_product_allergens: 'View product information',
    confirm: 'Proceed to payment',
    cancel: 'Back',
  },
  alert: {
    title: 'Important information about allergens',
    description: 'If you have allergies or intolerances, please check the product information before ordering.',
  },
};
